import type { AlertBannerCardProps } from '../../../types/alerts.d';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { Modal, ModalActionButtons } from '@hdir/ui/modal';
import React, { useState } from 'react';

import { Button } from '/react4xp/components/Button';
import { FontAwesomeIconWrapper } from '/react4xp/components/FontAwesomeIconWrapper';

import { AlertPoster } from './AlertPoster';
import { printComponent } from './printComponent';


export function PrintHelpDialog({
	content,
	date,
	image,
	title,
}: Pick< // Only want the CardAccordion ones, not the CardLink ones.
	AlertBannerCardProps,
		| 'content'
		| 'date'
		| 'image'
		| 'title'
>): JSX.Element {
	const [open, setOpen] = useState(false);
	return (
		<>
			<Button
				variant='secondary'
				onClick={() => setOpen(true)}
			>
				<FontAwesomeIconWrapper
					icon={faPrint}
				/>
				Skriv ut plakat (A4)
			</Button>
			<Modal
				isOpen={open}
				onCloseClick={() => setOpen(false)}
				title='For riktig format, velg følgende i printvinduet:'
			>
				<ol className='flex flex-col mb-0 space-y-lg'>
					<li>Velg <b>“Liggende”</b> layout/oppsett.</li>
					<li>Åpne <b>“Flere innstillinger”</b>.</li>
					<li>Huk av for <b>“Bakgrunnsgrafikk”</b>.</li>
				</ol>
				<ModalActionButtons>
					<Button variant="tertiary" onClick={() => setOpen(false)}>
						Lukk
					</Button>
					<Button
						variant="primary"
						onClick={ () => {
							printComponent({
								component: <AlertPoster
									appearance={content.appearance}
									descriptionHtml={content.description}
									expiresAt={date.expireStringOrUndef as string}
									imgSrc={image?.url}
									published={date.published}
									recommendationHtml={content.recommendation}
									title={title}
								/>,
								title,
							}).catch((error) => {
								console.error('Error printing component:', error);
							});
						}}
					>
						Åpne printvindu
					</Button>
				</ModalActionButtons>
			</Modal>
		</>
	);
}
